import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import ExternalReviewsTab from '../components/cx/ExternalReviewsTab';
import InternalFeedbackTab from '../components/cx/InternalFeedbackTab';
import FeedbackQrTab from '../components/cx/FeedbackQrTab';
import ContactsTab from '../components/cx/ContactsTab';

export default function AdminCustomerExperience() {
  const [tab, setTab] = useState('internal');

  return (
    <div data-testid="admin-cx-page">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5">
        <div>
          <h2 className="text-xl sm:text-2xl tracking-tight font-semibold text-[#1A2421]">Customer Experience</h2>
          <p className="text-sm text-[#5C6B64] mt-1">External reviews · Internal QR feedback · QR codes & landing pages</p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4" data-testid="cx-tabs">
          <TabsTrigger value="internal" data-testid="cx-tab-internal">Internal Feedback</TabsTrigger>
          <TabsTrigger value="external" data-testid="cx-tab-external">External Reviews</TabsTrigger>
          <TabsTrigger value="contacts" data-testid="cx-tab-contacts">Contacts</TabsTrigger>
          <TabsTrigger value="qr" data-testid="cx-tab-qr">QR & Landing</TabsTrigger>
        </TabsList>

        <TabsContent value="internal"><InternalFeedbackTab /></TabsContent>
        <TabsContent value="external"><ExternalReviewsTab /></TabsContent>
        <TabsContent value="contacts"><ContactsTab /></TabsContent>
        <TabsContent value="qr"><FeedbackQrTab /></TabsContent>
      </Tabs>
    </div>
  );
}
